<template>
  <div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      label-width="140px"
      class="demo-ruleForm"
    >
      <el-form-item label="是否是初次盘点：" prop="isFirstInventoryCheck">
        <div class="form_item_box">
          <el-select
            v-model="ruleForm.isFirstInventoryCheck"
            placeholder="请选择"
            clearable
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item>
        <div
          style="
            width: 100%;
            margin-left: -50px;
            display: flex;
            justify-content: center;
          "
        >
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
            style="width: 100px"
            >确定</el-button
          >
          <el-button @click="resetForm()" style="width: 100px">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cityList: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      ruleForm: {
        isFirstInventoryCheck: "",
      },
    };
  },
  props: ["row", "firstCheckModal"],
  created() {
    this.ruleForm.isFirstInventoryCheck = this.row.isFirstInventoryCheck;
    this.ruleForm.id = this.row.id;
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          $utils.api
            .load(
              "admin/system/customer/updateInventoryMark",
              this.ruleForm,
              "post"
            )
            .then((res) => {
              if (res.code == 200) {
                $utils.toast.success(res.msg);
                this.$emit("firstCheckModal");
              }
            });
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$emit("firstCheckModal");
    },
  },
};
</script>

<style>
</style>